module.exports = __webpack_public_path__ + "static/media/ayush-course.94aa3760.jpeg";